.root {
  position: absolute;
  top: -0.125rem;
  right: -0.125rem;
}

.text {
  position: absolute;
  top: 50%;
  left: 50%;

  font-size: 0.625rem;
  font-weight: var(--font-weight-semibold);
  color: var(--color-white);
  white-space: nowrap;
}
